// src/context/CartContext.js

import React, { createContext, useState } from "react";

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [shoppingCart, setShoppingCart] = useState([]);

  // اضافه کردن به سبد خرید (با مدیریت quantity)
  const addProductToCart = (product, productsList) => {
    const mainProduct = productsList.find(
      (p) => String(p.id) === String(product.id)
    );

    if (mainProduct) {
      setShoppingCart((prevCart) => {
        const existingProduct = prevCart.find(
          (item) => String(item.id) === String(mainProduct.id)
        );

        if (existingProduct) {
          return prevCart.map((item) =>
            String(item.id) === String(mainProduct.id)
              ? { ...item, quantity: item.quantity + 1 }
              : item
          );
        }

        return [...prevCart, { ...mainProduct, quantity: 1 }];
      });
    }
  };

  // کم کردن یکی از تعداد
  const decreaseQuantity = (productId) => {
    setShoppingCart((prevCart) => {
      const existingProduct = prevCart.find(
        (item) => String(item.id) === String(productId)
      );

      if (!existingProduct) return prevCart;

      if (existingProduct.quantity === 1) {
        return prevCart.filter(
          (item) => String(item.id) !== String(productId)
        );
      }

      return prevCart.map((item) =>
        String(item.id) === String(productId)
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    });
  };

  // زیاد کردن یکی از تعداد
  const increaseQuantity = (productId) => {
    setShoppingCart((prevCart) =>
      prevCart.map((item) =>
        String(item.id) === String(productId)
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  // حذف کامل محصول
  const removeProductFromCart = (productId) => {
    setShoppingCart((prevCart) =>
      prevCart.filter((item) => String(item.id) !== String(productId))
    );
  };

  // خالی کردن کامل سبد
  const emptyShoppingCart = () => {
    setShoppingCart([]);
  };

  // جایگزین کردن کل سبد خرید با نسخه اصلاح‌شده
  const replaceShoppingCart = (newCart) => {
    setShoppingCart(Array.isArray(newCart) ? newCart : []);
  };

  // محاسبه تعداد کل محصولات
  const cartCount = shoppingCart.reduce((total, item) => {
    return total + Number(item.quantity || 0);
  }, 0);

  return (
    <CartContext.Provider
      value={{
        shoppingCart,
        addProductToCart,
        decreaseQuantity,
        increaseQuantity,
        removeProductFromCart,
        emptyShoppingCart,
        replaceShoppingCart,
        cartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}